// SafetyBanner.js

function SafetyBanner() {
  return (
    <section className="safety-banner">
      <h3>⚠️ IMPORTANT REMINDER ⚠️</h3>
      <p>This is a platform for entertainment purposes only. Real gambling can lead to financial problems and addiction. Always play responsibly and within your means. If you feel you have a gambling problem, seek help immediately.</p>
    </section>
  );
}

export default SafetyBanner;